import React, { createContext, useState } from 'react'

import { SpendingBucket } from '../types'

interface SpendingBucketsStore {
  data?: SpendingBucket[]
  customBucketTotal?: number
  isLoading: boolean
  hasError: boolean
  update: (options: Record<string, any>) => void
}

export interface SpendingBucketsContextProps {
  spendingBucketsState: SpendingBucketsStore
}

export const SpendingBucketsContext = createContext(
  {} as SpendingBucketsContextProps,
)

export const SpendingBucketsProvider: React.FC = ({ children }) => {
  const [spendingBucketsState, setState] = useState<SpendingBucketsStore>({
    data: undefined,
    isLoading: true,
    hasError: false,
    customBucketTotal: undefined,
    update: /* istanbul ignore next */ (options): void => {
      setState(prevState => {
        return {
          ...prevState,
          ...options,
        }
      })
    },
  })

  return (
    <SpendingBucketsContext.Provider value={{ spendingBucketsState }}>
      {children}
    </SpendingBucketsContext.Provider>
  )
}
